module.exports = __webpack_public_path__ + "img/IMG-20220207-WA0032.c7c4aa3b.jpg";